// extracted by mini-css-extract-plugin
export var hideEditor = "_kz-2";
export var infoIcon = "_kz-3";
export var label = "_kz-1";
export var labelContainer = "_kz-0";
export var readonlyText = "_kz-4";